import { FC } from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import classNames from 'classnames';

import { RichLabelProps } from 'components/Shared/JabraLabel';
import { RadioButtonListFieldProps } from 'src/types/radioButtonList';

const TspRadioButtonList: FC<RadioButtonListFieldProps> = (props) => {
  const { field, value, onChange, errors, tracker } = props;
  const {
    model: { items, title, richTitle, cssClass, required },
    valueField,
  } = field;

  const hasAnyError = !!errors?.length;
  const formDesignerClasses = cssClass?.trim();
  const isRequired = !!required;

  const FieldValidationErrors = props.fieldValidationErrorsComponent as FC;
  const Label = props.labelComponent as FC<RichLabelProps>;
  const hasLabel = !!Label && (title || richTitle);
  const selectedValue = value ?? '';

  return (
    <>
      {hasLabel && <Label {...props} component="legend" />}
      <fieldset className={classNames('tsp-group', formDesignerClasses)} aria-label={title}>
        <RadioGroup.Root
          name={valueField.name}
          required={isRequired}
          aria-required={isRequired}
          value={selectedValue}
          onValueChange={(selectedItemValue) => {
            onChange(valueField.name, selectedItemValue, true, []);
          }}
          className="flex flex-wrap gap-x-8 gap-y-3 pt-2"
        >
          {items.map((item, index) => {
            const id = valueField.id + index;
            return (
              <label
                key={item.itemId}
                htmlFor={id}
                className="inline-flex cursor-pointer items-center gap-2 text-base text-[var(--tsp-text-primary)]"
              >
                <RadioGroup.Item
                  id={id}
                  value={item.value}
                  className={classNames(
                    'flex h-5 w-5 items-center justify-center rounded-full border-2 transition-colors',
                    hasAnyError ? 'border-error' : 'border-[var(--tsp-border)]'
                  )}
                  onFocus={() => {
                    tracker.onFocusField(field, item.value);
                  }}
                  onBlur={() => {
                    tracker.onBlurField(field, item.value, errors);
                  }}
                >
                  <RadioGroup.Indicator className="block h-2.5 w-2.5 rounded-full bg-[var(--tsp-border)]" />
                </RadioGroup.Item>
                <span>{item.text}</span>
              </label>
            );
          })}
        </RadioGroup.Root>
      </fieldset>

      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};

export default TspRadioButtonList;
